'use strict';

var d3 = require('d3');

/**
 * Simple Horizontal Bars
 *
 * Renders simple horizontal bars
 *
 * @returns {Function}
 * @constructor
 */
var SimpleHorizontalBars = function SimpleHorizontalBars() {
  /**
   * @param xPropertyName - a property name used to find X value
   * @returns {Function}
   * @constructor
   */
  return function (xPropertyName) {
    var params, scales;
    var barHeight;
    var shift = 0;
    /**
     *
     * @param container
     */
    var bars = function bars(container) {
      var selector = xPropertyName + '-bar';
      barHeight = barHeight || scales.yScale.rangeBand();
      var group = container.select('.groups').selectAll('.stack.visible');
      group.each(function (d) {
        if (d[xPropertyName] !== undefined) {
          var simpleBars = d3.select(this).selectAll('.' + selector).data([d]);
          simpleBars.enter().append('rect');
          simpleBars.attr({
            "class": function _class(d) {
              return selector + ' simple-horizontal-bar' + (d[xPropertyName] < 0 ? ' negative-value' : '');
            },
            x: function x(d) {
              return scales.xScale(Math.min(d[xPropertyName], 0));
            },
            y: shift,
            height: barHeight,
            width: function width(d) {
              return Math.abs(scales.xScale(0) - scales.xScale(d[xPropertyName]));
            }
          });
        }
      });
    };

    /**
     *  Setters and getters
     */

    bars.params = function (value) {
      params = value;
      return bars;
    };
    bars.scales = function (value) {
      scales = value;
      return bars;
    };
    bars.withHeight = function (value) {
      barHeight = value;
      return bars;
    };
    bars.withShift = function (value) {
      shift = value;
      return bars;
    };
    return bars;
  };
};
SimpleHorizontalBars.$inject = [];
module.exports = SimpleHorizontalBars;